<template>
  <div>
    <div class="header collapse d-lg-flex p-0" id="headerMenuCollapse">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-3 ml-auto text-right">
            <a class="mr-4" href="#" @click="saveData">
              Save
            </a>
            <a href="#" @click="logout">
              Sign out
            </a>
          </div>
          <div class="col-lg order-lg-first">
            <ul class="nav nav-tabs border-0 flex-column flex-lg-row">
              <li class="nav-item">
                <router-link to="/" class="nav-link" :class="currentPath == '/' ? 'active' : ''"><i class="fe fe-activity"></i>Summary</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/income" class="nav-link" :class="currentPath == '/income' ? 'active' : ''"><i class="fe fe-dollar-sign"></i>Income</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/expense" class="nav-link" :class="currentPath == '/expense' ? 'active' : ''"><i class="fe fe-users"></i>Expenses</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService'
import AlertService from '@/services/AlertService'
export default {
  name: 'Navbar',
  data () {
    return {
    }
  },
  mounted () {
    $('.nav li a').on('click', function () {
      $('.collapse').collapse('hide')
    })
  },
  computed: {
    currentPath () {
      return this.$route.path
    }
  },
  methods: {
    logout () {
      AuthService.logout()
    },
    saveData () {
      this.$store.dispatch('income/saveData')
      this.$store.dispatch('expense/saveData')
      AlertService.success('Save data successfully !')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue